import { PLAN_TYPE_LABELS } from 'components/Profile/Insurance/helper';
import { CreditCard, Stethoscope } from 'lucide-react';

export const MEDICAL_FORM_ID = 'medical-history-form';
export const INSURANCE_FORM_ID = 'insurance-form';

const insuranceSummary = (insurance) => {
  if (!insurance) return '';
  if (insurance.active === false) return 'Currently self-pay — no insurance on file';

  const carrier = insurance.insurance_company?.data?.attributes?.title;
  const planType = PLAN_TYPE_LABELS[insurance.plan_type];
  const details = [carrier, planType].filter(Boolean).join(' · ');

  return details ? `Currently ${details}` : 'No insurance on file';
};

export const PRIMARY_BTN = 'btn btn-neutral h-11 min-h-11 rounded-xl text-sm text-white';
export const SECONDARY_BTN = 'btn h-11 min-h-11 rounded-xl border-secondary-200 bg-white text-sm text-secondary-700 hover:border-secondary-300 hover:bg-secondary-50';

export const getUpdates = (insurance) => [
  {
    id: 'medical',
    icon: Stethoscope,
    iconClass: 'bg-purple-50 text-purple-500',
    title: 'My health or medications changed',
    description: 'New allergy, condition, or prescription',
  },
  {
    id: 'insurance',
    icon: CreditCard,
    iconClass: 'bg-blue-50 text-blue-500',
    title: 'My insurance changed',
    description: insuranceSummary(insurance),
  },
];
